import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { useCity } from "@/context/LocationContext";
import FrenchFlag from "@/components/FrenchFlag";

const NAV = [
    { to: "/", label: "Artisan serrurier", end: true },
    { to: "/ouverture-de-porte", label: "Ouverture de porte" },
    { to: "/depannage-serrurier", label: "Dépannage" },
    { to: "/remplacement-serrure", label: "Remplacement de serrure" },
    { to: "/faq", label: "FAQ" },
    { to: "/contact", label: "Contact / Devis" },
];

const Header = () => {
    const [open, setOpen] = useState(false);
    const { city, postal } = useCity();
    const subtitle = city
        ? `Serrurerie · ${city}${postal ? " " + postal : ""} · Dépannage Express`
        : "Serrurerie · Dépannage Express";

    return (
        <header className="sticky top-0 z-40 bg-white border-b border-black/10" data-testid="site-header">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between h-16 lg:h-20">
                    <Link to="/" className="flex items-center gap-3 group" data-testid="logo-home-link">
                        <img
                            src="/logo512.png"
                            alt="Artisan Serrurier Beauchamp"
                            className="h-12 sm:h-14 w-auto object-contain transition-transform duration-200 group-hover:scale-105"
                            data-testid="brand-logo"
                        />
                            <div className="leading-tight">
                                <div className="font-display font-bold text-base sm:text-lg uppercase tracking-tight flex items-center gap-2">
                                    Atelier Beauchamp
                                    <FrenchFlag />
                                </div>
                                <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-zinc-500 font-medium">{subtitle}</div>
                            </div>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-1" data-testid="desktop-nav">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                data-testid={`nav-link-${item.to.replace(/\//g, "") || "home"}`}
                                className={({ isActive }) =>
                                    `px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                                        isActive
                                            ? "text-[#0A0A0A] border-b-2 border-[#E63946]"
                                            : "text-zinc-600 hover:text-[#0A0A0A]"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                    </nav>

                    <div className="hidden lg:flex items-center gap-3">
                        <a
                            href="tel:+33649501843"
                            data-testid="header-call-btn"
                            className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#E63946] transition-colors duration-200"
                        >
                            <Phone className="h-4 w-4" strokeWidth={2.4} />
                            06 49 50 18 43
                        </a>
                    </div>

                    <button
                        type="button"
                        onClick={() => setOpen((v) => !v)}
                        className="lg:hidden p-2 -mr-2 text-zinc-700 hover:text-black"
                        aria-label="Menu"
                        data-testid="mobile-menu-toggle"
                    >
                        {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>
            </div>

            {open && (
                <div className="lg:hidden border-t border-black/10 bg-white" data-testid="mobile-nav">
                    <div className="px-4 py-4 space-y-1">
                        {NAV.map((item) => (
                            <NavLink
                                key={item.to}
                                to={item.to}
                                end={item.end}
                                onClick={() => setOpen(false)}
                                data-testid={`mobile-nav-link-${item.to.replace(/\//g, "") || "home"}`}
                                className={({ isActive }) =>
                                    `block px-3 py-3 text-base font-medium border-l-2 ${
                                        isActive
                                            ? "border-[#E63946] text-[#0A0A0A] bg-zinc-50"
                                            : "border-transparent text-zinc-600 hover:text-[#0A0A0A] hover:bg-zinc-50"
                                    }`
                                }
                            >
                                {item.label}
                            </NavLink>
                        ))}
                        <a
                            href="tel:+33649501843"
                            data-testid="mobile-call-btn"
                            className="mt-3 inline-flex w-full items-center justify-center gap-2 bg-[#E63946] text-white px-5 py-3 text-sm font-semibold hover:bg-[#D62828] transition-colors"
                        >
                            <Phone className="h-4 w-4" strokeWidth={2.4} />
                            Appeler 06 49 50 18 43
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;
